import React, { useCallback, useEffect, useState } from "react";
import { Form, Row } from "react-bootstrap";
import LoadingIcon from "../LoadingIcon";
import { Alert, Button, Snackbar } from "@mui/material";

const AccountDetails = () => {
  const [loadingState, setLoadingState] = useState(false);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({});
  const [notificationType, setNotificationType] = useState("success");
  const [message, setMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const token = localStorage.getItem("token");
  const vertical = "top";
  const horizontal = "center";

  const getDetails = useCallback(async () => {
    setLoading(true);
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}customerDetails`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          token,
        },
      }
    );

    const data = await response.json();

    setUser(data.User);
    setLoading(false);
  }, [token]);

  useEffect(() => {
    getDetails();
  }, [getDetails]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingState(true);
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}update/customer/${user._id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          token,
        },
        body: JSON.stringify({
          firstName: user.firstName,
          lastName: user.lastName,
          number: user.number,
        }),
      }
    );

    const data = await response.json();

    setShowNotification(true);
    if (data.status) {
      setNotificationType("success");
    } else {
      setNotificationType("error");
    }
    setMessage(data.message);
    setLoadingState(false);
    setTimeout(() => setShowNotification(false), 4000);
  };

  const handleChange = (e) => {
    setUser((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  return (
    <div className="p-2">
      {loading ? (
        <div className="h-screen flex items-center justify-center">
          <LoadingIcon />
        </div>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Snackbar
            open={showNotification}
            autoHideDuration={6000}
            anchorOrigin={{ vertical, horizontal }}
          >
            <Alert message={message} severity={notificationType}>
              {message}
            </Alert>
          </Snackbar>

          <Row>
            <div className="col-lg-6 mb-2">
              <Form.Group controlId="firstName">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter First Name"
                  value={user.firstName}
                  onChange={handleChange}
                  name="firstName"
                  required
                />
              </Form.Group>
            </div>

            <div className="col-lg-6 mb-2">
              <Form.Group controlId="lastName">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Last Name"
                  value={user.lastName}
                  onChange={handleChange}
                  name="lastName"
                  required
                />
              </Form.Group>
            </div>
          </Row>

          <Row>
            <div className="col-lg-6 mb-2">
              <Form.Group controlId="number">
                <Form.Label>Number</Form.Label>
                <Form.Control
                  placeholder="Enter Phone Number"
                  type="number"
                  value={user.number}
                  onChange={handleChange}
                  name="number"
                  required
                />
              </Form.Group>
            </div>
            <div className="col-lg-6 mb-2">
              <Form.Label className="mt-2">Email</Form.Label>
              <p className="font-semibold text-lg">{user.email}</p>
            </div>
          </Row>

          <div className="d-grid gap-2 mt-8">
            {loadingState ? (
              <Button
                sx={{
                  "& .MuiCircularProgress-root": {
                    height: "23px !important",
                    width: "23px !important",
                  },
                }}
              >
                <LoadingIcon />
              </Button>
            ) : (
              <Button
                variant="contained"
                type="submit"
                className="mb-5 !bg-[#101010]"
              >
                Save
              </Button>
            )}
          </div>
        </Form>
      )}
    </div>
  );
};

export default AccountDetails;
